/** Parse a string/number to a finite number; non-numeric values become 0. */
export const parseNumeric = (value: string | number | null | undefined): number => {
  const parsed = parseFloat(String(value ?? '0'));
  return Number.isFinite(parsed) ? parsed : 0;
};
